import { gql } from '@apollo/client';
import { CORE_USER_FIELDS } from '../fragments/user.fragment';
import { CORE_CLIENT_FIELDS } from '../fragments/client.fragment';
import { CORE_JOB_FIELDS } from '../fragments/job.fragment';
import { CORE_TALENT_FIELDS } from '../fragments/talent.fragment';

// const ME = gql`
//   ${CORE_USER_FIELDS}
//   query getMe {
//     me {
//       ...CoreUserFields

//     }
//   }
// `;

const ME = gql`
  ${CORE_USER_FIELDS}
  ${CORE_CLIENT_FIELDS}
  ${CORE_JOB_FIELDS}
  ${CORE_TALENT_FIELDS}
  query GetAccount {
    me {
      ...CoreUserFields
      client {
        ...CoreClientFields
        jobs {
          ...CoreJobFields
        }
      }
      talent {
        ...CoreTalentFields
      }
    }
  }
`;

export default ME;